var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-only-note"},[_c('p',{staticClass:"sk-note admin-only-note__text"},[_vm._v(_vm._s(_vm.$gettext('Admin only')))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }